module.exports = __webpack_public_path__ + "media/images/intro_slide_img_02-8c1bb2b1db82d9731b123fa10f4c5466.jpg";